module.exports = __webpack_public_path__ + "img/feature-3.44dc45fa.png";